import { useContext } from 'react';
import { styled } from '@core-ui/react-stitch';
import { BreakpointContext } from '@core-ui/breakpoint-provider';
import { Property } from 'csstype';
import { useMobile } from '../../hooks/mobile.hook';

type ProductInfoWrapperProps = {
  isBRRedesignEnabled: boolean
};

const sizeDependentStyles = {
  'small': {
    height: '6.25rem',
    padding: '0 0.5rem 0.5rem 0.5rem',
  },
  'medium': {
    height: '7.25rem',
    padding: '0 0.5rem 0.5rem 0.5rem',
  },
  'large': {
    height: '7.25rem',
    padding: '0 1rem 1.25rem 1rem',
  },
  'x-large': {
    height: '7.25rem',
    padding: '0 1.25rem 1.25rem 1.25rem',
  },
};

export const ProductInfoWrapper = styled.div(({ isBRRedesignEnabled }: ProductInfoWrapperProps) => {
  const { size } = useContext(BreakpointContext);

  const isMobileStyle = useMobile();
  let style = {
    ...sizeDependentStyles[size],
    position: 'absolute' as Property.Position,
    bottom: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as Property.FlexDirection,
    justifyContent: 'flex-end',
  };

  if (isMobileStyle) {
    style = {
      ...style,
      justifyContent: 'flex-start',
      height: '3.75rem'
    };
  }

  return isBRRedesignEnabled && (style);
});
